import styles from './index.less';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import { detailWechatNews } from '@/service/banner';
import { Helmet, useLocation } from '@umijs/max';
import { Image } from 'react-vant';

interface WechatNewsDataType {
  communityId?: string;
  communityName?: string;
  content?: string;
  createBy?: string;
  createTime?: string;
  image?: string;
  publishTime?: string;
  sequenceNbr?: string;
  status?: string;
  title?: string;
  topFlag?: string;
  updateBy?: string;
  updateTime?: string;
  urlPath?: string;
  viewCount?: number;
}
const NewsDatails = () => {
  console.log(useLocation());
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');

  const [WechatNewsData, setWechatNewsData] = useState<WechatNewsDataType>({});
  useEffect(() => {
    detailWechatNews({ sequenceNbr: data }).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        setWechatNewsData(res.data);
      } else {
        setWechatNewsData({});
      }
    });
  }, [data]);

  return (
    <div className={styles['newsDatails']}>
      <Helmet>
        <title>社区资讯详情</title>
      </Helmet>
      <div>
        {Object.entries(WechatNewsData).length ? (
          <>
            <div className={styles['newsDatailsBox']}>
              {WechatNewsData.title && (
                <div className={styles.title}>{WechatNewsData.title}</div>
              )}
              <div className={styles.timeBox}>
                <div className={styles.time}>
                  发布于{WechatNewsData.publishTime}
                </div>
                <div className={styles.time}>
                  {WechatNewsData.viewCount}浏览
                </div>
              </div>
              {WechatNewsData.image && (
                <div className={styles['demo-image']}>
                  <Image
                    width="100%"
                    height="100"
                    fit="cover"
                    src={WechatNewsData.image}
                  />
                </div>
              )}

              {WechatNewsData.content && (
                <div
                  dangerouslySetInnerHTML={{ __html: WechatNewsData.content }}
                ></div>
              )}
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default NewsDatails;
